<template>
<div>
    <div id="Navi">
        <div class="sub-box">
            <h2 title="HOME"><a href="/" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229"
                        height="219"></a></h2>
            <ul>
                <li><strong><a href="/company" v-bind:title="$t('tlCompany')"  v-on:click="clickMenu('company')">{{$t('tlCompany')}}</a></strong></li>
                <li><strong><a href="/products" v-bind:title="$t('tlProductCenter')" class="active">{{$t('tlProductCenter')}}</a></strong></li>
                <li><strong><a href="/service" v-bind:title="$t('tlService')"  v-on:click="clickMenu('service')">{{$t('tlService')}}</a></strong></li>
                <li><strong><a href="/media" v-bind:title="$t('tlMediaCenter')"  v-on:click="clickMenu('media')">{{$t('tlMediaCenter')}}</a></strong></li>
                <li><strong><a href="#mailto:xxx@arivo.com" v-bind:title="$t('tlContact')" class="ico-mail">{{$t('tlContact')}}</a></strong></li>
            </ul>
        </div>
    </div>
    <subNavi v-bind:selectedid="selectedSeries"></subNavi>
    
    <div id="Contents">
        <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>

            <siteMenu selectedid="tlProductCenter"></siteMenu>
        </div>

        <spNavi v-bind:selectedid="selectedSeries"></spNavi>

        <div id="Main" class="product__list">
            <ul>
                <li v-for="item in products" :class="'li_' + item.id">
                    <a v-bind:href="'/product_detail/' + item.id" target="_self" v-bind:title="item.name">
                        <div style="height: 300px; display: block;">
                            <img src="../../common/images/common/ico01.png" width="33" height="26" class="ico">
                            <span class="product__list--ttl">{{item.name}}</span>
                            <img v-bind:src="item.image1" alt="" style="height: 210px;">
                        </div>
                    </a>
                    <dl class="product__list--info btn">
                        <dt>{{$t('lbOverView')}}</dt>
                        <dd>
                            <img src="../../common/images/common/zoom.gif" class="floatR">
                            <div class="star-level">
                                <div v-bind:style="'width:' + item.overview + '%;'"></div>
                            </div>
                        </dd>
                    </dl>
                    <div class="popup box">
                        <div class="popup-container">
                            <a href="#0" class="popup-close btn_close">&nbsp;</a>
                            <div class="sub-box">
                                <div class="popup-ttl">{{item.name}}</div>
                                <p></p>
                                <p></p>
                                <div class="popup-ttl">{{$t('tlPerformanceRatings')}}</div>
                                <table cellpadding="0" cellspacing="0">
                                    <tr>
                                        <th><img src="../../common/images/common/sun.png" alt="sun"></th>
                                        <td class="p_r5">
                                            <div class="popup-sttl">
                                                <div class="popup-sttl"><img src="../../common/images/product/sttl01.png" v-bind:alt="$t('lbDryPerformance')"></div>
                                                <div class="product__list--attr"><span v-bind:style="'width:' + item.dry_performance + '%'"></span></div>
                                            </div>
                                        </td>
                                        <th><img src="../../common/images/common/wet.png" alt="wet"></th>
                                        <td>
                                            <div class="popup-sttl"><img src="../../common/images/product/sttl05.png" v-bind:alt="$t('lbWetPerformance')"></div>
                                            <div class="product__list--attr"><span v-bind:style="'width:' + item.wet_performance + '%'"></span></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><img src="../../common/images/common/road.png" alt="road"></th>
                                        <td class="p_r5">
                                            <div class="popup-sttl"><img src="../../common/images/product/sttl02.png" v-bind:alt="$t('lbOffRoadPerformance')"></div>
                                            <div class="product__list--attr"><span v-bind:style="'width:' + item.winter_performance + '%'"></span></div>
                                        </td>
                                        <th><img src="../../common/images/common/comfort.png" alt="comfort"></th>
                                        <td>
                                            <div class="popup-sttl"><img src="../../common/images/product/sttl04.png" v-bind:alt="$t('lbComfort')"></div>
                                            <div class="product__list--attr"><span v-bind:style="'width:' + item.comfort + '%'"></span></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><img src="../../common/images/common/sun.png"
                                                alt="sun"></th>
                                        <td class="p_r5">
                                            <div class="popup-sttl"><img src="../../common/images/product/sttl03.png" v-bind:alt="$t('lbQuietness')"></div>
                                            <div class="product__list--attr"><span v-bind:style="'width:' + item.quietness + '%'"></span></div>
                                        </td>
                                        <th>&nbsp;</th>
                                        <td>&nbsp;</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import $ from "jquery";
$(function() {
  $(document).on("click", ".btn", function(event) {
    //   alert("aaaaa")
    event.preventDefault();
    var li = $(event.target).closest("li");
    $(".box", li).addClass("is-visible");
  });
  $(document).on("click", ".box", function(event) {
    var li = $(event.target).closest("li");
    if (
      $(event.target).is(".btn_close", li) ||
      $(event.target).is(".box", li)
    ) {
      event.preventDefault();
      $(this).removeClass("is-visible");
    }
    // alert("bbbbbbb");
  });
  $(document).keyup(function(event) {
    var li = $(event.target).closest("li");
    if (event.which == "27") {
      $(".box", li).removeClass("is-visible");
    }
  });
});
import Navi from "components/common/navi";
import SubNavi from "components/product/subnavi";
import SpNavi from "components/product/spnavi";
import SiteMenu from "components/common/sitemenu";
import WebFooter from "components/common/footer";
import _util from "../../utils";
import productApi from "../../api/product-api";
export default {
  name: "Products",
  components: {
    Navi,
    SubNavi,
    SpNavi,
    SiteMenu,
    WebFooter
  },
  data() {
    return {
      selectedSeries: "",
      selectedSeriesId: "",
      products: []
    };
  },
  created: function() {
    var c_series = _util.getUrlParam("series");
    var c_seriesid = _util.getUrlParam("selected");
    if (c_series) {
      this.selectedSeries = c_series;
    } else {
      this.selectedSeries = "tlAllSeries";
    }
    if (c_seriesid) {
      this.selectedSeriesId = c_seriesid;
    }
    this.getProducts();
  },
  mounted: function() {},
  methods: {
    clickMenu(className) {
      $("body").attr("class", className);
    },
    getProducts() {
      var _this = this;
      productApi.getProducts(
        this.selectedSeriesId,
        function(response) {
          _this.products = response.data;
        },
        function(error) {}
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product/products.vue